import request from "@/utils/request";
// 订单列表
export function orderList(params) {
    return request({
        url: "delivery/order/index",
        method: "get",
        params,
    });
}
// 拒绝订单
export function rejectOrder(data) {
    return request({
        url: "delivery/order/reject-order",
        method: "post",
        data,
    });
}
// 同意取消订单
export function cancelOrder(data) {
    return request({
        url: "delivery/order/cancel-order",
        method: "post",
        data,
    });
}
// 删除订单
export function deleteOrder(data) {
    return request({
        url: "delivery/order/delete-order",
        method: "post",
        data,
    });
}
// 查看订单
export function orderInfo(params) {
    return request({
        url: "delivery/order/order-info",
        method: "get",
        params,
    });
}